
import { mapActions } from 'vuex'
import { footer } from '../customWhiteLabel'
export default {
  data() {
    return {
      dataForm: {
        telefone: '',
        endereco: {
          estado: '',
          cidade: '',
        },
      },
      loadingBtn: false,
      colorGradient: '',
      footer,
    }
  },
  head() {
    return {
      title: 'Revenda Senha Digital',
      meta: [
      {
        hid: 'description',
        name: 'description',
        content:
        'Agregue valor para seu negócio seja uma Revenda de Certificado Digital',
      },
      ],
    }
  },
  methods: {
    ...mapActions('slack', ['sendMessageSlack']),
    async save() {
      const formValidate = this.$refs.form.validate()
      if (!formValidate) {
        return false
      }
      
      const telefoneFormat = this.dataForm.telefone.replace(/[^0-9]/g, '')
      const estado = this.dataForm.endereco.estado.nome
      const cidade = this.dataForm.endereco.cidade
      
      const { endereco, telefone, ...res } = this.dataForm
      
      const message = {
        tipo: 'PA',
        telefone: telefoneFormat,
        endereco: {
          estado,
          cidade,
        },
        ...res,
      }
      this.loadingBtn = true
      try {
        await this.sendMessageSlack(message)
        this.$toast.success('Enviado com sucesso')
        this.$refs.form.reset()
      } catch (error) {
        console.error(error)
        this.$toast.error(error)
      } finally {
        this.loadingBtn = false
      }
    },
    contatParceiro() {
      // const linkUrl = 'https://wa.me/55' + this.footer.botaoWhatsapp
      // window.open(linkUrl, '_blank')
      
      const whatsappUrl = `https://wa.me/${this.footer.botaoWhatsapp}?text=${encodeURIComponent(this.footer.messageRevenda)}`;
      window.open(whatsappUrl, '_blanck');
    },
  },
}
